import Vue from 'vue'
import App from './App.vue'
import router from './router'
import BaiduMap from 'vue-baidu-map'

import './plugins/iview.js'
import './plugins/vant.js'
import store from './store'
import 'vant/lib/index.css';
import wechat from './assets/js/wechat.js'
import shareMsg from './assets/js/shareMsg.js'
// import "tailwindcss/tailwind.css"
// import './assets/css/tailwind.css'
Vue.config.productionTip = false
Vue.config.$store = store
Vue.use(BaiduMap, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key /
  ak: 'IrxtF2IWoZUU2w0S99T3AFEbIZZ9Ki7L'
  })


Vue.prototype.$wechat = wechat;
Vue.prototype.$shareMsg = shareMsg;
new Vue({
  router,
  render: h => h(App),
  store,

  mounted() {
    document.dispatchEvent(new Event('render-event'))
}
}).$mount('#app')

